import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TicketIcon, SearchIcon, CalendarIcon, MapPinIcon, CheckCircleIcon, ExternalLinkIcon, ArrowRightIcon, FilterIcon, GiftIcon, QrCodeIcon, DownloadIcon, ClipboardCheckIcon, ShoppingCartIcon, UserIcon, UsersIcon, CreditCardIcon, XIcon, CheckIcon, DollarSignIcon, BarChartIcon } from 'lucide-react';
const Tickets = () => {
  const [activeTab, setActiveTab] = useState('myTickets');
  const [showCart, setShowCart] = useState(false);
  const [showGiftForm, setShowGiftForm] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponError, setCouponError] = useState('');
  const [giftFormData, setGiftFormData] = useState({
    recipientName: '',
    recipientEmail: '',
    message: '',
    ticketId: ''
  });
  const [cartItems, setCartItems] = useState([{
    id: '1',
    eventName: 'Finance, Investment & Innovation',
    ticketType: 'Standard',
    price: 1500,
    quantity: 1
  }]);
  const tickets = [{
    id: '1',
    eventName: 'Yoga In The Park',
    date: 'Aug 10, 2023',
    time: '7:00 AM',
    location: 'Karura Forest',
    ticketType: 'Standard',
    ticketId: 'YIP-22374',
    status: 'active',
    url: 'https://kenyabuzz.com/tickets/yip-22374',
    organizer: 'KenyaBuzz'
  }, {
    id: '2',
    eventName: 'Nairobi Tech Conference',
    date: 'Sep 15, 2023',
    time: '9:00 AM',
    location: 'Radisson Blu Hotel',
    ticketType: 'VIP',
    ticketId: 'NTC-8834',
    status: 'active',
    url: 'https://eventbrite.com/tickets/ntc-8834',
    organizer: 'Eventbrite'
  }, {
    id: '3',
    eventName: 'Kenyan Music Festival',
    date: 'Jul 28, 2023',
    time: '4:00 PM',
    location: 'Carnivore Grounds',
    ticketType: 'Regular',
    ticketId: 'KMF-3452',
    status: 'past',
    url: 'https://ticketsasa.com/tickets/kmf-3452',
    organizer: 'TicketSasa'
  }];
  const validateTicket = (ticketId: string) => {
    // Simulate ticket validation
    alert(`Ticket ${ticketId} has been validated! This ticket is valid.`);
  };
  const handleGiftTicket = (ticketId: string) => {
    setGiftFormData({
      ...giftFormData,
      ticketId
    });
    setShowGiftForm(true);
  };
  const handleGiftSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Ticket has been gifted to ${giftFormData.recipientName}!`);
    setShowGiftForm(false);
    setGiftFormData({
      recipientName: '',
      recipientEmail: '',
      message: '',
      ticketId: ''
    });
  };
  const handleGiftFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setGiftFormData({
      ...giftFormData,
      [name]: value
    });
  };
  const handleApplyCoupon = () => {
    if (couponCode === 'FIRST10') {
      alert('Coupon applied successfully! 10% discount has been applied.');
      setCouponError('');
    } else {
      setCouponError('Invalid coupon code. Please try again.');
    }
  };
  const handleRemoveFromCart = (itemId: string) => {
    setCartItems(cartItems.filter(item => item.id !== itemId));
  };
  const handleCheckout = () => {
    setShowPaymentModal(true);
  };
  const handlePayment = () => {
    alert('Payment successful! Your tickets have been added to your account.');
    setShowPaymentModal(false);
    setCartItems([]);
  };
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  };
  return <div className="p-4 pb-20 max-w-4xl mx-auto" data-id="element-3679">
      <h1 className="text-2xl font-bold mb-4 flex items-center" data-id="element-3680">
        <TicketIcon className="w-6 h-6 mr-2" data-id="element-3681" />
        Tickets
      </h1>
      <div className="mb-6" data-id="element-3682">
        <div className="flex border-b border-gray-200 dark:border-gray-700 overflow-x-auto" data-id="element-3683">
          <button className={`py-2 px-4 whitespace-nowrap ${activeTab === 'myTickets' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setActiveTab('myTickets')} data-id="element-3684">
            My Tickets
          </button>
          <button className={`py-2 px-4 whitespace-nowrap ${activeTab === 'validate' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setActiveTab('validate')} data-id="element-3685">
            Validate Tickets
          </button>
          <button className={`py-2 px-4 whitespace-nowrap ${activeTab === 'gift' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setActiveTab('gift')} data-id="element-3686">
            Gift a Ticket
          </button>
          <button className={`py-2 px-4 whitespace-nowrap ${activeTab === 'purchase' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setActiveTab('purchase')} data-id="element-3687">
            Purchase Tickets
          </button>
          <button className={`py-2 px-4 whitespace-nowrap ${activeTab === 'partner' ? 'border-b-2 border-gray-800 dark:border-gray-200 font-medium' : 'text-gray-500 dark:text-gray-400'}`} onClick={() => setActiveTab('partner')} data-id="element-3688">
            Partner With Us
          </button>
        </div>
      </div>
      <div className="relative mb-4" data-id="element-3689">
        <input type="text" placeholder="Search your tickets..." className="w-full p-3 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-800 dark:text-gray-200" data-id="element-3690" />
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-3691" />
        <button className="absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-3692">
          <FilterIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-3693" />
        </button>
      </div>
      {/* My Tickets Tab */}
      {activeTab === 'myTickets' && <div data-id="element-3694">
          <h2 className="text-lg font-medium mb-3" data-id="element-3695">My Tickets</h2>
          {tickets.filter(ticket => ticket.status === 'active').length > 0 ? <div className="space-y-4 mb-6" data-id="element-3696">
              <h3 className="text-md font-medium mb-2" data-id="element-3697">Upcoming Events</h3>
              {tickets.filter(ticket => ticket.status === 'active').map(ticket => <div key={ticket.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-3698">
                    <div className="p-4" data-id="element-3699">
                      <div className="flex justify-between items-start" data-id="element-3700">
                        <h4 className="font-bold dark:text-gray-200" data-id="element-3701">
                          {ticket.eventName}
                        </h4>
                        <span className="text-xs bg-gray-200 dark:bg-gray-700 dark:text-gray-200 rounded-full px-2 py-0.5" data-id="element-3702">
                          {ticket.ticketType}
                        </span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600 dark:text-gray-300 mt-2" data-id="element-3703">
                        <CalendarIcon className="w-4 h-4 mr-1" data-id="element-3704" />
                        <span data-id="element-3705">{ticket.date}</span>
                        <span className="mx-2" data-id="element-3706">•</span>
                        <span data-id="element-3707">{ticket.time}</span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600 dark:text-gray-300 mt-1" data-id="element-3708">
                        <MapPinIcon className="w-4 h-4 mr-1" data-id="element-3709" />
                        <span data-id="element-3710">{ticket.location}</span>
                      </div>
                      <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700" data-id="element-3711">
                        <div className="flex justify-between items-center" data-id="element-3712">
                          <div data-id="element-3713">
                            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3714">
                              Ticket ID:
                            </span>
                            <span className="text-sm font-medium ml-1 dark:text-gray-300" data-id="element-3715">
                              {ticket.ticketId}
                            </span>
                          </div>
                          <div className="flex space-x-2" data-id="element-3716">
                            <button onClick={() => validateTicket(ticket.ticketId)} className="px-2 py-1 border border-gray-300 dark:border-gray-600 rounded-md text-xs flex items-center dark:text-gray-200" data-id="element-3717">
                              <QrCodeIcon className="w-3 h-3 mr-1" data-id="element-3718" />
                              Show QR
                            </button>
                            <button onClick={() => handleGiftTicket(ticket.id)} className="px-2 py-1 border border-gray-300 dark:border-gray-600 rounded-md text-xs flex items-center dark:text-gray-200" data-id="element-3719">
                              <GiftIcon className="w-3 h-3 mr-1" data-id="element-3720" />
                              Gift
                            </button>
                            <a href={ticket.url} target="_blank" rel="noopener noreferrer" className="px-3 py-1 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md text-xs flex items-center" data-id="element-3721">
                              View
                              <ExternalLinkIcon className="w-3 h-3 ml-1" data-id="element-3722" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 border-t border-gray-200 dark:border-gray-700" data-id="element-3723">
                      <div className="flex items-center" data-id="element-3724">
                        <CheckCircleIcon className="w-5 h-5 text-gray-700 dark:text-gray-300 mr-2" data-id="element-3725" />
                        <span className="text-sm dark:text-gray-300" data-id="element-3726">
                          Ticket confirmed
                        </span>
                      </div>
                    </div>
                  </div>)}
            </div> : <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-8 text-center text-gray-500 dark:text-gray-400 mb-6" data-id="element-3727">
              <TicketIcon className="w-10 h-10 mx-auto mb-2" data-id="element-3728" />
              <p data-id="element-3729">You don't have any upcoming tickets</p>
              <Link to="/events" className="text-sm underline mt-2 inline-block" data-id="element-3730">
                Browse Events
              </Link>
            </div>}
          {tickets.filter(ticket => ticket.status === 'past').length > 0 && <div data-id="element-3731">
              <h3 className="text-md font-medium mb-2 dark:text-gray-200" data-id="element-3732">
                Past Events
              </h3>
              <div className="space-y-4" data-id="element-3733">
                {tickets.filter(ticket => ticket.status === 'past').map(ticket => <div key={ticket.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden opacity-75" data-id="element-3734">
                      <div className="p-4" data-id="element-3735">
                        <div className="flex justify-between items-start" data-id="element-3736">
                          <h4 className="font-bold dark:text-gray-200" data-id="element-3737">
                            {ticket.eventName}
                          </h4>
                          <span className="text-xs bg-gray-200 dark:bg-gray-700 dark:text-gray-200 rounded-full px-2 py-0.5" data-id="element-3738">
                            {ticket.ticketType}
                          </span>
                        </div>
                        <div className="flex items-center text-sm text-gray-600 dark:text-gray-300 mt-2" data-id="element-3739">
                          <CalendarIcon className="w-4 h-4 mr-1" data-id="element-3740" />
                          <span data-id="element-3741">{ticket.date}</span>
                          <span className="mx-2" data-id="element-3742">•</span>
                          <span data-id="element-3743">{ticket.time}</span>
                        </div>
                        <div className="flex items-center text-sm text-gray-600 dark:text-gray-300 mt-1" data-id="element-3744">
                          <MapPinIcon className="w-4 h-4 mr-1" data-id="element-3745" />
                          <span data-id="element-3746">{ticket.location}</span>
                        </div>
                        <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700" data-id="element-3747">
                          <div className="flex justify-between items-center" data-id="element-3748">
                            <div data-id="element-3749">
                              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3750">
                                Ticket ID:
                              </span>
                              <span className="text-sm font-medium ml-1 dark:text-gray-300" data-id="element-3751">
                                {ticket.ticketId}
                              </span>
                            </div>
                            <a href={ticket.url} target="_blank" rel="noopener noreferrer" className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-md text-xs flex items-center" data-id="element-3752">
                              View
                              <ExternalLinkIcon className="w-3 h-3 ml-1" data-id="element-3753" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="bg-gray-50 dark:bg-gray-800 p-4 border-t border-gray-200 dark:border-gray-700" data-id="element-3754">
                        <div className="flex items-center" data-id="element-3755">
                          <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3756">
                            Event completed
                          </span>
                        </div>
                      </div>
                    </div>)}
              </div>
            </div>}
        </div>}
      {/* Validate Tickets Tab */}
      {activeTab === 'validate' && <div data-id="element-3757">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-3758">
            Validate Tickets
          </h2>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-6" data-id="element-3759">
            <div className="text-center mb-6" data-id="element-3760">
              <QrCodeIcon className="w-16 h-16 mx-auto mb-2 text-gray-400 dark:text-gray-500" data-id="element-3761" />
              <h3 className="text-lg font-medium dark:text-gray-200" data-id="element-3762">
                Scan Ticket QR Code
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-3763">
                Use the JoinToday.co.ke app to scan and validate tickets
              </p>
            </div>
            <div className="flex justify-center" data-id="element-3764">
              <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2 text-sm mr-2" data-id="element-3765">
                Download Android App
              </a>
              <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2 text-sm" data-id="element-3766">
                Download iOS App
              </a>
            </div>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3767">
            <h3 className="text-lg font-medium mb-4 dark:text-gray-200" data-id="element-3768">
              Manual Ticket Validation
            </h3>
            <div className="mb-4" data-id="element-3769">
              <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-3770">
                Event Name
              </label>
              <select className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" data-id="element-3771">
                <option value="" data-id="element-3772">Select an event</option>
                <option value="yoga" data-id="element-3773">Yoga In The Park</option>
                <option value="tech" data-id="element-3774">Nairobi Tech Conference</option>
                <option value="music" data-id="element-3775">Kenyan Music Festival</option>
              </select>
            </div>
            <div className="mb-4" data-id="element-3776">
              <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-3777">
                Ticket ID
              </label>
              <input type="text" placeholder="Enter ticket ID (e.g. YIP-22374)" className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" data-id="element-3778" />
            </div>
            <button className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2 text-sm w-full flex items-center justify-center" data-id="element-3779">
              <ClipboardCheckIcon className="w-4 h-4 mr-2" data-id="element-3780" />
              Validate Ticket
            </button>
          </div>
        </div>}
      {/* Gift a Ticket Tab */}
      {activeTab === 'gift' && <div data-id="element-3781">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-3782">
            Gift a Ticket
          </h2>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-6" data-id="element-3783">
            <h3 className="text-md font-medium mb-4 dark:text-gray-200" data-id="element-3784">
              Select a Ticket to Gift
            </h3>
            {tickets.filter(ticket => ticket.status === 'active').length > 0 ? <div className="space-y-4" data-id="element-3785">
                {tickets.filter(ticket => ticket.status === 'active').map(ticket => <div key={ticket.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3786">
                      <div className="flex justify-between items-start" data-id="element-3787">
                        <div data-id="element-3788">
                          <h4 className="font-medium dark:text-gray-200" data-id="element-3789">
                            {ticket.eventName}
                          </h4>
                          <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3790">
                            {ticket.date} • {ticket.time}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-3791">
                            Ticket ID: {ticket.ticketId}
                          </p>
                        </div>
                        <button onClick={() => handleGiftTicket(ticket.id)} className="px-3 py-1 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md text-sm flex items-center" data-id="element-3792">
                          <GiftIcon className="w-4 h-4 mr-1" data-id="element-3793" />
                          Gift This Ticket
                        </button>
                      </div>
                    </div>)}
              </div> : <div className="text-center py-6 text-gray-500 dark:text-gray-400" data-id="element-3794">
                <GiftIcon className="w-10 h-10 mx-auto mb-2" data-id="element-3795" />
                <p data-id="element-3796">You don't have any tickets to gift</p>
                <Link to="/events" className="text-sm underline mt-2 inline-block" data-id="element-3797">
                  Purchase Tickets First
                </Link>
              </div>}
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3798">
            <h3 className="text-md font-medium mb-4 dark:text-gray-200" data-id="element-3799">
              Or Purchase a Gift Ticket
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-3800">
              Buy a ticket as a gift for someone special. They'll receive an
              email with instructions on how to claim it.
            </p>
            <Link to="/events" className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2 text-sm w-full flex items-center justify-center" data-id="element-3801">
              <ShoppingCartIcon className="w-4 h-4 mr-2" data-id="element-3802" />
              Browse Events to Purchase Gift Tickets
            </Link>
          </div>
        </div>}
      {/* Purchase Tickets Tab */}
      {activeTab === 'purchase' && <div data-id="element-3803">
          <h2 className="text-lg font-medium mb-3 dark:text-gray-200" data-id="element-3804">
            Purchase Tickets
          </h2>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-6" data-id="element-3805">
            <h3 className="text-md font-medium mb-4 dark:text-gray-200" data-id="element-3806">
              Your Shopping Cart
            </h3>
            {cartItems.length > 0 ? <div data-id="element-3807">
                <div className="space-y-4 mb-4" data-id="element-3808">
                  {cartItems.map(item => <div key={item.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3809">
                      <div className="flex justify-between items-start" data-id="element-3810">
                        <div data-id="element-3811">
                          <h4 className="font-medium dark:text-gray-200" data-id="element-3812">
                            {item.eventName}
                          </h4>
                          <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3813">
                            Ticket Type: {item.ticketType}
                          </p>
                          <p className="text-sm font-medium mt-1 dark:text-gray-300" data-id="element-3814">
                            KES {item.price.toLocaleString()}
                          </p>
                        </div>
                        <div className="flex items-center" data-id="element-3815">
                          <div className="flex items-center border border-gray-300 dark:border-gray-600 rounded-md mr-2" data-id="element-3816">
                            <button className="px-2 py-1 text-sm dark:text-gray-200" data-id="element-3817">
                              -
                            </button>
                            <span className="px-2 py-1 text-sm dark:text-gray-200" data-id="element-3818">
                              {item.quantity}
                            </span>
                            <button className="px-2 py-1 text-sm dark:text-gray-200" data-id="element-3819">
                              +
                            </button>
                          </div>
                          <button onClick={() => handleRemoveFromCart(item.id)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" data-id="element-3820">
                            <XIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-3821" />
                          </button>
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mb-4" data-id="element-3822">
                  <div className="flex justify-between items-center mb-2" data-id="element-3823">
                    <span className="text-sm dark:text-gray-300" data-id="element-3824">Subtotal</span>
                    <span className="font-medium dark:text-gray-200" data-id="element-3825">
                      KES {calculateTotal().toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between items-center mb-2" data-id="element-3826">
                    <span className="text-sm dark:text-gray-300" data-id="element-3827">
                      Service Fee
                    </span>
                    <span className="font-medium dark:text-gray-200" data-id="element-3828">
                      KES 0
                    </span>
                  </div>
                  <div className="flex justify-between items-center mb-4" data-id="element-3829">
                    <span className="text-sm font-medium dark:text-gray-300" data-id="element-3830">
                      Total
                    </span>
                    <span className="font-bold dark:text-gray-200" data-id="element-3831">
                      KES {calculateTotal().toLocaleString()}
                    </span>
                  </div>
                  <div className="flex items-center mb-4" data-id="element-3832">
                    <input type="text" placeholder="Enter coupon code" value={couponCode} onChange={e => setCouponCode(e.target.value)} className="flex-1 p-2 border border-gray-300 dark:border-gray-600 rounded-l-md text-sm dark:bg-gray-800 dark:text-gray-200" data-id="element-3833" />
                    <button onClick={handleApplyCoupon} className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-r-md px-3 py-2 text-sm" data-id="element-3834">
                      Apply
                    </button>
                  </div>
                  {couponError && <p className="text-sm text-red-500 mb-4" data-id="element-3835">{couponError}</p>}
                  <button onClick={handleCheckout} className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2 text-sm w-full flex items-center justify-center" data-id="element-3836">
                    <CreditCardIcon className="w-4 h-4 mr-2" data-id="element-3837" />
                    Proceed to Checkout
                  </button>
                </div>
                <div className="border border-gray-200 dark:border-gray-700 rounded-md p-4 bg-gray-50 dark:bg-gray-800" data-id="element-3838">
                  <h4 className="text-sm font-medium mb-2 dark:text-gray-200" data-id="element-3839">
                    Payment Process Reminder
                  </h4>
                  <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-2" data-id="element-3840">
                    <li data-id="element-3841">
                      You'll be redirected to JoinToday.co.ke Money platform to
                      securely process your payment.
                    </li>
                    <li data-id="element-3842">
                      For mobile money, an M-Pesa prompt from Tanda Agent will
                      appear to complete your transaction.
                    </li>
                    <li data-id="element-3843">
                      This is a standard process to ensure secure payments. If
                      you have any questions, our support team is happy to help.
                    </li>
                  </ul>
                  <p className="text-xs mt-2 dark:text-gray-400" data-id="element-3844">
                    By purchasing this ticket, you agree to our
                    <button onClick={() => alert('Events Disclaimer details')} className="underline mx-1 dark:text-gray-300" data-id="element-3845">
                      JoinToday Events Disclaimer
                    </button>
                  </p>
                </div>
              </div> : <div className="text-center py-6 text-gray-500 dark:text-gray-400" data-id="element-3846">
                <ShoppingCartIcon className="w-10 h-10 mx-auto mb-2" data-id="element-3847" />
                <p data-id="element-3848">Your cart is empty</p>
                <Link to="/events" className="text-sm underline mt-2 inline-block" data-id="element-3849">
                  Browse Events
                </Link>
              </div>}
          </div>
        </div>}
      {/* Partner With Us Tab */}
      {activeTab === 'partner' && <div className="py-4" data-id="element-3850">
          <div className="mb-8" data-id="element-3851">
            <h2 className="text-2xl font-bold mb-4 dark:text-gray-200" data-id="element-3852">
              Event Ticketing Solutions
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6" data-id="element-3853">
              Streamline your event management with our comprehensive ticketing
              platform. Create, sell, and manage tickets for your events with
              ease.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-3854">
              <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-3855">
                <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3856">
                  <TicketIcon className="w-8 h-8 text-gray-600 dark:text-gray-300" data-id="element-3857" />
                </div>
                <h3 className="font-bold text-lg mb-2 dark:text-gray-200" data-id="element-3858">
                  Ticket Management
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3859">
                  Create multiple ticket types with customizable pricing,
                  availability, and features.
                </p>
              </div>
              <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-3860">
                <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3861">
                  <DollarSignIcon className="w-8 h-8 text-gray-600 dark:text-gray-300" data-id="element-3862" />
                </div>
                <h3 className="font-bold text-lg mb-2 dark:text-gray-200" data-id="element-3863">
                  Secure Payments
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3864">
                  Accept payments via M-Pesa, credit cards, and other popular
                  payment methods.
                </p>
              </div>
              <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-3865">
                <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3866">
                  <BarChartIcon className="w-8 h-8 text-gray-600 dark:text-gray-300" data-id="element-3867" />
                </div>
                <h3 className="font-bold text-lg mb-2 dark:text-gray-200" data-id="element-3868">
                  Real-time Analytics
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3869">
                  Track sales, attendance, and customer demographics with
                  powerful reporting tools.
                </p>
              </div>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-8" data-id="element-3870">
              <div className="p-6" data-id="element-3871">
                <h3 className="text-xl font-bold mb-4 dark:text-gray-200" data-id="element-3872">
                  Monetization Options for Event Organizers
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3873">
                  <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3874">
                    <h4 className="font-bold mb-2 dark:text-gray-200" data-id="element-3875">
                      Become an Event Organizer
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-3876">
                      Create and sell tickets to your own events
                    </p>
                    <ul className="text-sm space-y-2 mb-4" data-id="element-3877">
                      <li className="flex items-center" data-id="element-3878">
                        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3879">
                          <span className="text-xs" data-id="element-3880">✓</span>
                        </div>
                        <span className="dark:text-gray-300" data-id="element-3881">
                          Create unlimited events
                        </span>
                      </li>
                      <li className="flex items-center" data-id="element-3882">
                        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3883">
                          <span className="text-xs" data-id="element-3884">✓</span>
                        </div>
                        <span className="dark:text-gray-300" data-id="element-3885">
                          Customizable event pages
                        </span>
                      </li>
                      <li className="flex items-center" data-id="element-3886">
                        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3887">
                          <span className="text-xs" data-id="element-3888">✓</span>
                        </div>
                        <span className="dark:text-gray-300" data-id="element-3889">
                          Real-time sales tracking
                        </span>
                      </li>
                    </ul>
                    <Link to="/seller-info" className="block text-center w-full border border-gray-300 dark:border-gray-600 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md py-2 text-sm" data-id="element-3890">
                      Sign up as an organizer
                    </Link>
                  </div>
                  <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-3891">
                    <h4 className="font-bold mb-2 dark:text-gray-200" data-id="element-3892">
                      Become an Event Influencer
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-3893">
                      Promote events and earn commission on ticket sales
                    </p>
                    <ul className="text-sm space-y-2 mb-4" data-id="element-3894">
                      <li className="flex items-center" data-id="element-3895">
                        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3896">
                          <span className="text-xs" data-id="element-3897">✓</span>
                        </div>
                        <span className="dark:text-gray-300" data-id="element-3898">
                          Unique referral links
                        </span>
                      </li>
                      <li className="flex items-center" data-id="element-3899">
                        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3900">
                          <span className="text-xs" data-id="element-3901">✓</span>
                        </div>
                        <span className="dark:text-gray-300" data-id="element-3902">
                          5-10% commission per sale
                        </span>
                      </li>
                      <li className="flex items-center" data-id="element-3903">
                        <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3904">
                          <span className="text-xs" data-id="element-3905">✓</span>
                        </div>
                        <span className="dark:text-gray-300" data-id="element-3906">
                          Promotional materials provided
                        </span>
                      </li>
                    </ul>
                    <Link to="/seller-info" className="block text-center w-full border border-gray-300 dark:border-gray-600 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md py-2 text-sm" data-id="element-3907">
                      Sign up as an influencer
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-8" data-id="element-3908">
              <h3 className="text-xl font-bold mb-4 dark:text-gray-200" data-id="element-3909">
                Partner with JoinToday.co.ke
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3910">
                Are you a venue owner or service provider for events? Partner
                with us to reach more clients.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3911">
                <div data-id="element-3912">
                  <h4 className="font-bold mb-2 dark:text-gray-200" data-id="element-3913">
                    For Venues
                  </h4>
                  <ul className="text-sm space-y-2" data-id="element-3914">
                    <li className="flex items-center" data-id="element-3915">
                      <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3916">
                        <span className="text-xs" data-id="element-3917">✓</span>
                      </div>
                      <span className="dark:text-gray-300" data-id="element-3918">
                        List your venue in our directory
                      </span>
                    </li>
                    <li className="flex items-center" data-id="element-3919">
                      <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3920">
                        <span className="text-xs" data-id="element-3921">✓</span>
                      </div>
                      <span className="dark:text-gray-300" data-id="element-3922">
                        Get booking inquiries
                      </span>
                    </li>
                    <li className="flex items-center" data-id="element-3923">
                      <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3924">
                        <span className="text-xs" data-id="element-3925">✓</span>
                      </div>
                      <span className="dark:text-gray-300" data-id="element-3926">
                        Showcase your space with photos
                      </span>
                    </li>
                  </ul>
                </div>
                <div data-id="element-3927">
                  <h4 className="font-bold mb-2 dark:text-gray-200" data-id="element-3928">
                    For Service Providers
                  </h4>
                  <ul className="text-sm space-y-2" data-id="element-3929">
                    <li className="flex items-center" data-id="element-3930">
                      <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3931">
                        <span className="text-xs" data-id="element-3932">✓</span>
                      </div>
                      <span className="dark:text-gray-300" data-id="element-3933">
                        Catering, decor, sound, lighting, etc.
                      </span>
                    </li>
                    <li className="flex items-center" data-id="element-3934">
                      <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3935">
                        <span className="text-xs" data-id="element-3936">✓</span>
                      </div>
                      <span className="dark:text-gray-300" data-id="element-3937">
                        Connect with event organizers
                      </span>
                    </li>
                    <li className="flex items-center" data-id="element-3938">
                      <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3939">
                        <span className="text-xs" data-id="element-3940">✓</span>
                      </div>
                      <span className="dark:text-gray-300" data-id="element-3941">
                        Build your service portfolio
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <Link to="/seller-info" className="block text-center w-full border border-gray-300 dark:border-gray-600 rounded-md py-2 text-sm dark:text-gray-200" data-id="element-3942">
                Learn more about partnerships
              </Link>
            </div>
            <div className="text-center" data-id="element-3943">
              <h3 className="text-xl font-bold mb-4 dark:text-gray-200" data-id="element-3944">
                Ready to Get Started?
              </h3>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-3945">
                <Link to="/seller-info" className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-6 py-3" data-id="element-3946">
                  View All Monetization Options
                </Link>
                <Link to="/register?type=seller" className="border border-gray-300 dark:border-gray-600 rounded-md px-6 py-3 dark:text-gray-200" data-id="element-3947">
                  Create Partner Account
                </Link>
              </div>
            </div>
          </div>
        </div>}
      {/* Gift Ticket Form Modal */}
      {showGiftForm && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-3948">
          <div className="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full p-6" data-id="element-3949">
            <div className="flex justify-between items-center mb-4" data-id="element-3950">
              <h3 className="text-lg font-bold dark:text-gray-200" data-id="element-3951">
                Gift a Ticket
              </h3>
              <button onClick={() => setShowGiftForm(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-3952">
                <XIcon className="w-5 h-5 dark:text-gray-300" data-id="element-3953" />
              </button>
            </div>
            <form onSubmit={handleGiftSubmit} data-id="element-3954">
              <div className="mb-4" data-id="element-3955">
                <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-3956">
                  Recipient's Name
                </label>
                <input type="text" name="recipientName" value={giftFormData.recipientName} onChange={handleGiftFormChange} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" required data-id="element-3957" />
              </div>
              <div className="mb-4" data-id="element-3958">
                <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-3959">
                  Recipient's Email
                </label>
                <input type="email" name="recipientEmail" value={giftFormData.recipientEmail} onChange={handleGiftFormChange} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" required data-id="element-3960" />
              </div>
              <div className="mb-4" data-id="element-3961">
                <label className="block text-sm font-medium mb-1 dark:text-gray-300" data-id="element-3962">
                  Personal Message (Optional)
                </label>
                <textarea name="message" value={giftFormData.message} onChange={handleGiftFormChange} rows={3} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" data-id="element-3963"></textarea>
              </div>
              <button type="submit" className="w-full bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md py-2 text-sm flex items-center justify-center" data-id="element-3964">
                <GiftIcon className="w-4 h-4 mr-2" data-id="element-3965" />
                Send Gift Ticket
              </button>
            </form>
          </div>
        </div>}
      {/* Payment Modal */}
      {showPaymentModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-3966">
          <div className="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full p-6" data-id="element-3967">
            <div className="flex justify-between items-center mb-4" data-id="element-3968">
              <h3 className="text-lg font-bold dark:text-gray-200" data-id="element-3969">
                Complete Your Purchase
              </h3>
              <button onClick={() => setShowPaymentModal(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-3970">
                <XIcon className="w-5 h-5 dark:text-gray-300" data-id="element-3971" />
              </button>
            </div>
            <div className="border border-gray-200 dark:border-gray-700 rounded-md p-4 mb-4" data-id="element-3972">
              <h4 className="font-medium mb-2 dark:text-gray-200" data-id="element-3973">
                Booking Summary
              </h4>
              <div className="space-y-2 mb-3" data-id="element-3974">
                <div className="flex justify-between" data-id="element-3975">
                  <span className="text-sm dark:text-gray-300" data-id="element-3976">
                    Event Name:
                  </span>
                  <span className="text-sm font-medium dark:text-gray-200" data-id="element-3977">
                    Finance, Investment & Innovation
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3978">
                  <span className="text-sm dark:text-gray-300" data-id="element-3979">
                    Booked Ticket Type:
                  </span>
                  <span className="text-sm font-medium dark:text-gray-200" data-id="element-3980">
                    Standard
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3981">
                  <span className="text-sm dark:text-gray-300" data-id="element-3982">
                    Ticket Price:
                  </span>
                  <span className="text-sm font-medium dark:text-gray-200" data-id="element-3983">
                    KES 1,500.00
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-3984">
                  <span className="text-sm dark:text-gray-300" data-id="element-3985">Attendees:</span>
                  <span className="text-sm font-medium dark:text-gray-200" data-id="element-3986">
                    1 Person
                  </span>
                </div>
              </div>
              <div className="border-t border-gray-200 dark:border-gray-700 pt-2" data-id="element-3987">
                <div className="flex justify-between font-bold" data-id="element-3988">
                  <span className="dark:text-gray-200" data-id="element-3989">Total Amount:</span>
                  <span className="dark:text-gray-200" data-id="element-3990">KES 1,500.00</span>
                </div>
              </div>
            </div>
            <div className="mb-4" data-id="element-3991">
              <h4 className="font-medium mb-2 dark:text-gray-200" data-id="element-3992">
                Select Payment Method
              </h4>
              <div className="space-y-2" data-id="element-3993">
                <label className="flex items-center p-3 border border-gray-300 dark:border-gray-600 rounded-md cursor-pointer" data-id="element-3994">
                  <input type="radio" name="paymentMethod" defaultChecked className="mr-2" data-id="element-3995" />
                  <span className="dark:text-gray-200" data-id="element-3996">M-Pesa</span>
                </label>
                <label className="flex items-center p-3 border border-gray-300 dark:border-gray-600 rounded-md cursor-pointer" data-id="element-3997">
                  <input type="radio" name="paymentMethod" className="mr-2" data-id="element-3998" />
                  <span className="dark:text-gray-200" data-id="element-3999">Credit/Debit Card</span>
                </label>
                <label className="flex items-center p-3 border border-gray-300 dark:border-gray-600 rounded-md cursor-pointer" data-id="element-4000">
                  <input type="radio" name="paymentMethod" className="mr-2" data-id="element-4001" />
                  <span className="dark:text-gray-200" data-id="element-4002">Bank Transfer</span>
                </label>
              </div>
            </div>
            <div className="border border-gray-200 dark:border-gray-700 rounded-md p-4 mb-4 bg-gray-50 dark:bg-gray-700" data-id="element-4003">
              <h4 className="text-sm font-medium mb-2 dark:text-gray-200" data-id="element-4004">
                Payment Process Reminder
              </h4>
              <ul className="text-xs text-gray-600 dark:text-gray-300 space-y-2" data-id="element-4005">
                <li data-id="element-4006">
                  You'll be redirected to JoinToday.co.ke Money platform to
                  securely process your payment.
                </li>
                <li data-id="element-4007">
                  For mobile money, an M-Pesa prompt from Tanda Agent will
                  appear to complete your transaction.
                </li>
              </ul>
            </div>
            <div className="flex space-x-3" data-id="element-4008">
              <button onClick={() => setShowPaymentModal(false)} className="flex-1 border border-gray-300 dark:border-gray-600 rounded-md py-2 text-sm dark:text-gray-200" data-id="element-4009">
                Cancel
              </button>
              <button onClick={handlePayment} className="flex-1 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md py-2 text-sm flex items-center justify-center" data-id="element-4010">
                <CreditCardIcon className="w-4 h-4 mr-2" data-id="element-4011" />
                Pay Now
              </button>
            </div>
          </div>
        </div>}
      {/* Floating Cart Button (only if there are items and cart is not shown) */}
      {cartItems.length > 0 && !showCart && <button onClick={() => setShowCart(true)} className="fixed bottom-20 right-20 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-full p-3 shadow-lg" data-id="element-4012">
          <div className="relative" data-id="element-4013">
            <ShoppingCartIcon className="w-6 h-6" data-id="element-4014" />
            <span className="absolute -top-2 -right-2 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold" data-id="element-4015">
              {cartItems.reduce((total, item) => total + item.quantity, 0)}
            </span>
          </div>
        </button>}
      {/* Cart Slide-in Panel */}
      {showCart && <div className="fixed inset-y-0 right-0 max-w-sm w-full bg-white dark:bg-gray-800 shadow-lg z-50 flex flex-col" data-id="element-4016">
          <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center" data-id="element-4017">
            <h3 className="font-bold dark:text-gray-200" data-id="element-4018">Your Cart</h3>
            <button onClick={() => setShowCart(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-4019">
              <XIcon className="w-5 h-5 dark:text-gray-300" data-id="element-4020" />
            </button>
          </div>
          <div className="flex-1 overflow-auto p-4" data-id="element-4021">
            {cartItems.length > 0 ? <div className="space-y-4" data-id="element-4022">
                {cartItems.map(item => <div key={item.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-3" data-id="element-4023">
                    <div className="flex justify-between items-start" data-id="element-4024">
                      <div data-id="element-4025">
                        <h4 className="font-medium dark:text-gray-200" data-id="element-4026">
                          {item.eventName}
                        </h4>
                        <p className="text-xs text-gray-600 dark:text-gray-300" data-id="element-4027">
                          Ticket Type: {item.ticketType}
                        </p>
                        <p className="text-sm font-medium mt-1 dark:text-gray-300" data-id="element-4028">
                          KES {item.price.toLocaleString()}
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-4029">
                        <div className="flex items-center border border-gray-300 dark:border-gray-600 rounded-md mr-2" data-id="element-4030">
                          <button className="px-2 py-0.5 text-xs dark:text-gray-200" data-id="element-4031">
                            -
                          </button>
                          <span className="px-2 py-0.5 text-xs dark:text-gray-200" data-id="element-4032">
                            {item.quantity}
                          </span>
                          <button className="px-2 py-0.5 text-xs dark:text-gray-200" data-id="element-4033">
                            +
                          </button>
                        </div>
                        <button onClick={() => handleRemoveFromCart(item.id)} className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full" data-id="element-4034">
                          <XIcon className="w-3 h-3 text-gray-500 dark:text-gray-400" data-id="element-4035" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div> : <div className="text-center py-10 text-gray-500 dark:text-gray-400" data-id="element-4036">
                <ShoppingCartIcon className="w-10 h-10 mx-auto mb-2" data-id="element-4037" />
                <p data-id="element-4038">Your cart is empty</p>
                <button onClick={() => setShowCart(false)} className="text-sm underline mt-2 inline-block" data-id="element-4039">
                  Continue Shopping
                </button>
              </div>}
          </div>
          {cartItems.length > 0 && <div className="p-4 border-t border-gray-200 dark:border-gray-700" data-id="element-4040">
              <div className="flex justify-between items-center mb-2" data-id="element-4041">
                <span className="text-sm dark:text-gray-300" data-id="element-4042">Subtotal</span>
                <span className="font-medium dark:text-gray-200" data-id="element-4043">
                  KES {calculateTotal().toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between items-center mb-4" data-id="element-4044">
                <span className="text-sm font-medium dark:text-gray-300" data-id="element-4045">
                  Total
                </span>
                <span className="font-bold dark:text-gray-200" data-id="element-4046">
                  KES {calculateTotal().toLocaleString()}
                </span>
              </div>
              <button onClick={() => {
          setShowCart(false);
          setActiveTab('purchase');
        }} className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2 text-sm w-full flex items-center justify-center" data-id="element-4047">
                Checkout
              </button>
            </div>}
        </div>}
      {/* WhatsApp Contact Button */}
      <a href="https://wa.me/254100254254" target="_blank" rel="noopener noreferrer" className="fixed bottom-4 right-4 z-50 bg-white dark:bg-gray-800 rounded-full p-2 shadow-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700" aria-label="Contact us on WhatsApp" data-id="element-4048">
        <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center" data-id="element-4049">
          <span className="text-xl" data-id="element-4050">💬</span>
        </div>
      </a>
    </div>;
};
export default Tickets;